const token = localStorage.getItem("token");
export const header = {
  "Content-Type": "application/json",
};

if (token) {
  header["authtoken"] = token;
}
